import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { adminNav } from '../adminNavRegistry';
import { CommandProviderState } from '../types';

export const useTabsResults = (query: string): CommandProviderState => {
  const navigate = useNavigate();
  const normalized = query.trim().toLowerCase();

  const results = useMemo(() => {
    const matching = normalized
      ? adminNav.filter((item) => item.label.toLowerCase().includes(normalized))
      : adminNav;

    return matching.map((item) => ({
      id: `tab:${item.to}`,
      label: item.label,
      icon: item.icon,
      onSelect: () => navigate(item.to),
    }));
  }, [normalized, navigate]);

  return { results, loading: false };
};
